// #updateProductStock
// SKU must exist inside window.carpe_variants product looop
const QUIZ_SKU_REVISIONS = {
    // Original: Replacement 
    replacements: {
        // 'CP-UA-LC': 'CP-CU-KITM',
        // 'CP-UA-RW': 'CP-CU-KITM',
        // 'CP-UA-SW': 'CP-CU-KITM',
        // 'CP-CU-KITC': 'CP-UA-FP',
        // 'CP-UA-MB': 'CP-CU-KITM',
        // 'CP-UA-FF': 'CP-CU-KITM',
    },
    // if these skus are recommended, remove from cart payloads
    removals: ['CP-12M']
}

const QuizConfig = {
    /* freeGifts[quiz_type] = 'primary' | 'tiktok' */
    freeGifts: {
        primary: [
            // {
            //     id: 'answer_freegift_wipes',
            //     variantId: '39794201428101',
            //     image: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/quiz-free-gift-timer-product-wipes.jpg?v=1767141829&width=400",
            //     timerImage: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/quiz-free-gift-timer-tnail-wipes.png?v=1767141829&width=100",
            //     title: '2 Face Wipes',
            //     subtitle: 'Sweat Absorbing',
            //     details: '2 free wipes'
            // },
            {
                id: 'answer_freegift_uawipes',
                variantId: '41518765080709',
                image: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/2uawipestransparent.png?v=1770997679&width=400",
                timerImage: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/2uawipestransparent.png?v=1770997679&width=100",
                title: '2 Underarm Wipes',
                subtitle: 'Antiperspirant',
                details: '2 free wipes'
            },
            {
                id: 'answer_freegift_exfoliator',
                variantId: '39368536785029',
                image: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/quiz-free-gift-timer-product-exfoliator.jpg?v=1767141829&width=400",
                timerImage: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/quiz-free-gift-timer-tnail-exfoliator.jpg?v=1767141829&width=100",
                title: 'Exfoliating Underarm Scrub',
                subtitle: 'Clinical Grade',
                details: 'free 100mL bottle'
            },
        ],
        tiktok: [
            {
                id: 'answer_freegift_tiktok',
                variantId: '39818239115397',
                image: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/quiz-free-gift-toiletry-bag.jpg?v=1767367884&width=400",
                timerImage: "https://cdn.shopify.com/s/files/1/0335/1622/4645/files/quiz-free-gift-toiletry-bag.jpg?v=1767367884&width=100",
                title: 'Toiletry Bag',
                subtitle: '$15 value',
                details: 'Size: 3.75" x 3.15" x 9.75"',
            },
        ],
    },
    /*
    questions[X].answers[Y].quizData supported fields:
    - sku
    - userSegment <-- only valid on type.single
    - subscription <-- only valid on type.single
    */
    flows: {
        // Base flow - always active, contains main questions 
        base: {
            questions: [
                {
                    id: 'question_freegift',
                    type: 'freegift',
                    title: 'Pick a FREE gift with your first order',
                    subtitle:
                        'Your order also qualifies for FREE Shipping and a Money Back Guarantee<span class="double-dagger">‡</span>. Try Risk Free Today!',
                    ctaText: 'BEGIN 1-MINUTE QUIZ',
                },
                {
                    id: 'question_unhappy',
                    type: 'single',
                    title: 'Are you unhappy with the amount you sweat?',
                    answers: [
                        { id: 'answer_unhappy_yes', text: 'Yes' },
                        { id: 'answer_unhappy_no', text: 'No' },
                    ],
                },
                {
                    id: 'question_currentap',
                    type: 'single',
                    title: 'Are you dissatisfied with your current antiperspirant or deodorant product(s)?',
                    answers: [
                        { id: 'answer_currentap_yes', text: 'Yes' },
                        { id: 'answer_currentap_no', text: 'No' },
                    ],
                },
                {
                    id: 'question_wheresweat',
                    type: 'multiple',
                    title: 'Where do you sweat?',
                    subtitle: 'Select all that apply',
                    answers: [
                        { id: 'answer_underarm', text: 'Underarms', quizData: { sku: 'CP-10-15' } },
                        { id: 'answer_face', text: 'Face' },
                        { id: 'answer_foot', text: 'Feet', quizData: { sku: 'CP-02' } },
                        { id: 'answer_breast', text: 'Chest, or Under Breast', quizData: { sku: 'CP-13' } },
                        { id: 'answer_hand', text: 'Hands', quizData: { sku: 'CP-01' } },
                        { id: 'answer_groin', text: 'Groin/Crotch' },
                        { id: 'answer_scalp', text: 'Scalp', quizData: { sku: 'CP-SR-KIT' } },
                    ],
                },
                {
                    id: 'question_subscription',
                    type: 'single',
                    title: 'Are you interested in saving up to 30%?',
                    answers: [
                        { id: 'answer_sub_yes', text: 'Yes', quizData: { subscription: true } },
                        { id: 'answer_sub_no', text: 'No' },
                    ],
                },
                {
                    id: 'question_email',
                    type: 'email',
                    title: 'Enter your email to receive your personalized sweat solution and a FREE gift.',
                    subtitle: 'Assessment Complete',
                    ctaText: 'SEE RESULTS',
                    skipText: 'I just want to see my results',
                },
            ],
        },
        underarm: {
            priority: 1,
            triggerAnswer: 'answer_underarm',
            insertAfter: 'question_wheresweat',
            questions: [
                {
                    id: 'question_mostsweat',
                    type: 'single',
                    title: 'When do you typically experience the most unwanted sweat?',
                    subtitle: 'Select the one that describes you best',
                    answers: [
                        {
                            id: 'answer_mostsweat_sweatyperson',
                            text: "All the time - I'm just a sweaty person",
                            quizData: { userSegment: 'hyperhydrosis', sku: 'CP-CU-KITC' },
                        },
                        {
                            id: 'answer_mostsweat_hyperhydrosis',
                            text: 'All the time - I have hyperhydrosis (excessive sweating)',
                            quizData: { userSegment: 'hyperhydrosis', sku: 'CP-CU-KITC' },
                        },
                        { id: 'answer_mostsweat_nervous', text: "Mostly when I'm nervous", quizData: { userSegment: 'situational', sku: 'CP-CU-KITC' } },
                        { id: 'answer_mostsweat_exercise', text: "Mostly when I'm active, or exercising", quizData: { userSegment: 'situational', sku: 'CP-CU-KITC' } },
                        { id: 'answer_mostsweat_heat', text: "Mostly when it's hot or humid", quizData: { userSegment: 'situational', sku: 'CP-CU-KITC' } },
                    ],
                },
                {
                    id: 'question_smell',
                    type: 'single',
                    title: 'What do you prefer to smell like the most?',
                    subtitle: 'Select one',
                    answers: [
                        { id: 'answer_smell_beach', text: 'The beach', quizData: { sku: 'CP-CU-KITM' } },
                        { id: 'answer_smell_clean', text: 'Fresh & clean', quizData: { sku: 'CP-CU-KITC' } },
                        { id: 'answer_smell_spa', text: 'The spa', quizData: { sku: 'CP-UA-LC' } },
                        { id: 'answer_smell_flowers', text: 'Field of flowers', quizData: { sku: 'CP-UA-RW' } },
                        { id: 'answer_smell_wood', text: 'The woods', quizData: { sku: 'CP-UA-SW' } },
                        { id: 'answer_smell_mountains', text: 'The mountains', quizData: { sku: 'CP-UA-MB' } },
                        { id: 'answer_smell_none', text: 'I prefer unscented products', quizData: { sku: 'CP-UA-FF' } },
                    ],
                },
            ],
        },
        face: {
            priority: 2,
            triggerAnswer: 'answer_face',
            insertAfter: 'question_wheresweat',
            questions: [
                {
                    id: 'question_makeup',
                    type: 'single',
                    title: 'Do you wear makeup?',
                    subtitle: '(This will help us customize your solution)',
                    answers: [
                        { id: 'makeup_yes', text: 'Yes', quizData: { sku: 'CP-ADM' } },
                        { id: 'makeup_no', text: 'No', quizData: { sku: 'CP-11' } },
                    ],
                },
            ],
        },
        groin: {
            priority: 3,
            triggerAnswers: ['answer_groin'],
            insertAfter: 'question_wheresweat',
            questions: [
                {
                    id: 'question_gender',
                    type: 'single',
                    title: 'With which gender do you identify? This will help us determine the best groin product for you',
                    answers: [
                        { id: 'answer_gender_female', text: 'Female', quizData: { sku: 'CP-12F' } },
                        { id: 'answer_gender_male', text: 'Male', quizData: { sku: 'CP-12M' } },
                        { id: 'answer_gender_other', text: 'Other', quizData: { sku: 'CP-12M' } },
                    ],
                },
            ],
        },
    },
};

/**
 * QuizState - Centralized state management with persistence
 */
class QuizState {
    static QUIZ_URL_BASE = 'carpe-quiz';

    constructor(quizType = 'primary') {
        this.quizType = quizType;
        this.storageKey = `carpe_quiz_state_${quizType}`;

        this.data = {
            currentQuestionId: null,
            selectedAnswers: new Set(),
            timerValue: '10:00',
            c: null,
            quizData: {
                recommendedSkus: [],
                subscriptionPreference: false,
                userSegment: null, // 'hyperhydrosis' or 'situational'
            },
            activeFlows: ['base'],
            compiledQuestions: [],
            referrerUrl: null,
            questionsCompleted: 0,
            highestProgressShown: 0,
        };

        // Restore from session first (to preserve original referrer if exists)
        this.restoreFromSession();
        // Then capture referrer only if not already set (first time loading)
        this.captureReferrer();
    }

    getCurrentQuestionId() {
        return this.data.currentQuestionId;
    }

    setCurrentQuestion(questionId) {
        this.data.currentQuestionId = questionId;
        this.persist();
    }

    hasAnswer(answerId) {
        return this.data.selectedAnswers.has(answerId);
    }

    addAnswer(answerId) {
        this.data.selectedAnswers.add(answerId);
        this.persist();
    }

    setEmail(email) {
        this.data.email = email;
        this.persist();
    }

    getEmail() {
        return this.data.email;
    }

    removeAnswer(answerId) {
        this.data.selectedAnswers.delete(answerId);
        this.persist();
    }

    clearAnswersForQuestion(questionAnswers) {
        questionAnswers.forEach(answer => {
            this.data.selectedAnswers.delete(answer.id);
        });
        this.persist();
    }

    getSelectedAnswers() {
        return Array.from(this.data.selectedAnswers);
    }

    setTimer(value) {
        this.data.timerValue = value;
        this.persist();
    }

    getTimer() {
        return this.data.timerValue;
    }

    setTimerGiftImage(imageUrl) {
        this.data.c = imageUrl;
    }

    getTimerGiftImage() {
        return this.data.c;
    }

    setUserSegment(segment) {
        this.data.quizData.userSegment = segment;
        this.persist();
    }

    getUserSegment() {
        return this.data.quizData.userSegment;
    }

    setRecommendedSkus(skus) {
        this.data.quizData.recommendedSkus = skus;
        this.persist();
    }

    getRecommendedSkus() {
        return this.data.quizData.recommendedSkus;
    }

    setSubscriptionPreference(value) {
        this.data.quizData.subscriptionPreference = value;
        this.persist();
    }

    getSubscriptionPreference() {
        return this.data.quizData.subscriptionPreference;
    }

    setActiveFlows(flows) {
        this.data.activeFlows = flows;
        this.persist();
    }

    getActiveFlows() {
        return this.data.activeFlows;
    }

    addActiveFlow(flowName) {
        if (!this.data.activeFlows.includes(flowName)) {
            this.data.activeFlows.push(flowName);
            this.persist();
        }
    }

    setCompiledQuestions(questions) {
        this.data.compiledQuestions = questions;
        this.persist();
    }

    getCompiledQuestions() {
        return this.data.compiledQuestions;
    }

    captureReferrer() {
        // Only capture if not already set (preserve existing referrer if restored from session)
        if (this.data.referrerUrl !== null) {
            return;
        }

        const referrer = document.referrer;

        // Check if referrer exists and is not empty
        if (!referrer || referrer.trim() === '') {
            this.data.referrerUrl = null;
            return;
        }

        try {
            const referrerUrl = new URL(referrer);
            const currentUrl = new URL(window.location.href);

            // Check if referrer is from mycarpe.com domain (check hostname)
            const isValidDomain = referrerUrl.hostname.includes('mycarpe.com') ||
                referrerUrl.hostname === currentUrl.hostname;

            if (!isValidDomain) {
                this.data.referrerUrl = null;
                return;
            }

            // Check that referrer is not the quiz page itself (avoid circular navigation)
            // Check if pathname contains quiz-related paths
            if (referrerUrl.pathname.includes(QuizState.QUIZ_URL_BASE)) {
                this.data.referrerUrl = null;
                return;
            }

            // Store the full URL
            this.data.referrerUrl = referrer;
        } catch (e) {
            // Invalid URL, store null
            console.error('Error parsing referrer URL:', e);
            this.data.referrerUrl = null;
        }
    }

    // Get referrer URL
    getReferrerUrl() {
        return this.data.referrerUrl;
    }

    // Set referrer URL
    setReferrerUrl(url) {
        this.data.referrerUrl = url;
        this.persist();
    }

    getQuestionsCompleted() {
        return this.data.questionsCompleted;
    }

    setQuestionsCompleted(value) {
        this.data.questionsCompleted = value;
        this.persist();
    }

    getHighestProgressShown() {
        return this.data.highestProgressShown;
    }

    setHighestProgressShown(value) {
        this.data.highestProgressShown = value;
        this.persist();
    }

    // Serialize for session storage
    serialize() {
        return {
            currentQuestionId: this.data.currentQuestionId,
            selectedAnswers: Array.from(this.data.selectedAnswers),
            timerValue: this.data.timerValue,
            quizData: {
                recommendedSkus: this.data.quizData.recommendedSkus,
                subscriptionPreference: this.data.quizData.subscriptionPreference,
                userSegment: this.data.quizData.userSegment,
            },
            activeFlows: this.data.activeFlows,
            compiledQuestions: this.data.compiledQuestions,
            referrerUrl: this.data.referrerUrl,
            email: this.data.email,
            questionsCompleted: this.data.questionsCompleted,
            highestProgressShown: this.data.highestProgressShown
        };
    }

    // Deserialize from session storage
    deserialize(data) {
        if (data.currentQuestionId) {
            this.data.currentQuestionId = data.currentQuestionId;
        }
        if (data.selectedAnswers) {
            this.data.selectedAnswers = new Set(data.selectedAnswers);
        }
        if (data.timerValue) {
            this.data.timerValue = data.timerValue;
        }

        // Handle quizData - support both new format (quizData object) and legacy format (top-level userSegment)
        if (data.quizData) {
            if (data.quizData.recommendedSkus !== undefined) {
                this.data.quizData.recommendedSkus = data.quizData.recommendedSkus;
            }
            if (data.quizData.subscriptionPreference !== undefined) {
                this.data.quizData.subscriptionPreference = data.quizData.subscriptionPreference;
            }
            if (data.quizData.userSegment !== undefined) {
                this.data.quizData.userSegment = data.quizData.userSegment;
            }
        } else if (data.userSegment !== undefined) {
            // Legacy format: migrate top-level userSegment to quizData
            this.data.quizData.userSegment = data.userSegment;
        }

        if (data.activeFlows) {
            this.data.activeFlows = data.activeFlows;
        }
        if (data.compiledQuestions) {
            this.data.compiledQuestions = data.compiledQuestions;
        }
        if (data.referrerUrl !== undefined) {
            this.data.referrerUrl = data.referrerUrl;
        }
        if (data.email !== undefined) {
            this.data.email = data.email;
        }
        if (data.questionsCompleted !== undefined) {
            this.data.questionsCompleted = data.questionsCompleted;
        }
        if (data.highestProgressShown !== undefined) {
            this.data.highestProgressShown = data.highestProgressShown;
        }
    }

    // Save to session storage
    persist() {
        try {
            sessionStorage.setItem(this.storageKey, JSON.stringify(this.serialize()));
        } catch (e) {
            console.error('Error saving quiz state:', e);
        }
    }

    // Restore from session storage
    restoreFromSession() {
        try {
            const saved = sessionStorage.getItem(this.storageKey);
            if (saved) {
                const data = JSON.parse(saved);
                this.deserialize(data);
            }
        } catch (e) {
            console.error('Error restoring quiz state:', e);
        }
    }

    // Clear all state
    reset() {
        this.data = {
            currentQuestionId: null,
            selectedAnswers: new Set(),
            timerValue: '10:00',
            c: null,
            quizData: {
                recommendedSkus: [],
                subscriptionPreference: false,
                userSegment: null,
            },
            activeFlows: ['base'],
            compiledQuestions: [],
            referrerUrl: null,
            questionsCompleted: 0,
            highestProgressShown: 0
        };
        sessionStorage.removeItem(this.storageKey);
    }
}


/**
 * QuizFlowController - Manages flow navigation and conditional logic
 */

class QuizFlowController {
    constructor(config, state, quizType) {
        this.config = config;
        this.state = state;
        this.quizType = quizType || 'primary';
    }

    getFreeGifts() {
        const configKey = this.quizType || 'primary';
        return this.config.freeGifts[configKey] || [];
    }

    initializeFlows() {
        const initialFlow = 'base';
        this.state.setActiveFlows([initialFlow]);

        // Compile initial questions
        this.compileQuestions();

        // Set default gift
        this.setDefaultGift();

        // Update derived state from any restored answers
        this.updateDerivedState();
    }

    setDefaultGift() {
        const gifts = this.getFreeGifts();
        const selectedAnswers = this.state.getSelectedAnswers();

        // Check if ANY gift ID is already in selectedAnswers
        const hasGiftSelected = gifts.some(gift => selectedAnswers.includes(gift.id));

        if (hasGiftSelected) {
            // A gift is already selected - just ensure timer image is set
            const selectedGift = this.getSelectedGift();
            if (selectedGift && selectedGift.timerImage) {
                this.state.setTimerGiftImage(selectedGift.timerImage);
            }
        } else {
            // No gift selected - always select the first gift
            const firstGift = gifts[0];
            if (firstGift) {
                this.state.setTimerGiftImage(firstGift.timerImage);
                this.state.addAnswer(firstGift.id);
            }
        }
    }

    compileQuestions() {
        const activeFlows = this.state.getActiveFlows();
        const compiledQuestions = [];
        const processedFlows = new Set();

        // Separate base flows from conditional flows
        const baseFlows = [];
        const conditionalFlows = [];

        activeFlows.forEach(flowName => {
            if (processedFlows.has(flowName)) {
                return;
            }

            const flow = this.config.flows[flowName];

            if (!flow || !flow.questions) {
                return;
            }

            if (flow.insertAfter) {
                // This is a conditional flow
                conditionalFlows.push({ flowName, flow });
            } else {
                // Base flow
                baseFlows.push({ flowName, flow });
            }

            processedFlows.add(flowName);
        });

        // Process base flows first
        baseFlows.forEach(({ flow }) => {
            compiledQuestions.push(...flow.questions);
        });

        // Group conditional flows by insertAfter
        const flowsByInsertAfter = {};
        conditionalFlows.forEach(({ flowName, flow }) => {
            const insertAfter = flow.insertAfter;
            if (!flowsByInsertAfter[insertAfter]) {
                flowsByInsertAfter[insertAfter] = [];
            }
            flowsByInsertAfter[insertAfter].push({ flowName, flow });
        });

        // Sort each group by priority (lower number = appears first)
        // Default priority to 999 if not specified (appears last)
        Object.keys(flowsByInsertAfter).forEach(insertAfter => {
            flowsByInsertAfter[insertAfter].sort((a, b) => {
                const priorityA = a.flow.priority !== undefined ? a.flow.priority : 999;
                const priorityB = b.flow.priority !== undefined ? b.flow.priority : 999;
                return priorityA - priorityB;
            });
        });

        // Process conditional flows in priority order
        Object.keys(flowsByInsertAfter).forEach(insertAfter => {
            const flows = flowsByInsertAfter[insertAfter];
            const insertIndex = compiledQuestions.findIndex(q => q.id === insertAfter);

            if (insertIndex !== -1) {
                // Collect all questions from flows with this insertAfter, in priority order
                const questionsToInsert = [];
                flows.forEach(({ flow }) => {
                    questionsToInsert.push(...flow.questions);
                });

                // Insert all questions at once after the specified question
                compiledQuestions.splice(insertIndex + 1, 0, ...questionsToInsert);
            }
        });

        this.state.setCompiledQuestions(compiledQuestions);
    }

    addConditionalFlows(answerId) {
        const flowsToAdd = [];

        Object.entries(this.config.flows).forEach(([flowName, flow]) => {
            // Skip if already active
            if (this.state.getActiveFlows().includes(flowName)) {
                return;
            }

            // Check single trigger
            if (flow.triggerAnswer && flow.triggerAnswer === answerId) {
                flowsToAdd.push(flowName);
                return;
            }

            // Check multiple triggers
            if (flow.triggerAnswers && flow.triggerAnswers.includes(answerId)) {
                flowsToAdd.push(flowName);
                return;
            }
        });

        // Add triggered flows and recompile
        if (flowsToAdd.length > 0) {
            flowsToAdd.forEach(flowName => {
                this.state.addActiveFlow(flowName);
            });
            this.compileQuestions();
        }
    }

    getCurrentQuestion() {
        const questions = this.state.getCompiledQuestions();
        const currentId = this.state.getCurrentQuestionId();
        return questions.find(q => q.id === currentId);
    }

    getQuestionById(questionId) {
        const questions = this.state.getCompiledQuestions();
        return questions.find(q => q.id === questionId);
    }

    getCurrentIndex() {
        const questions = this.state.getCompiledQuestions();
        const currentId = this.state.getCurrentQuestionId();
        return questions.findIndex(q => q.id === currentId);
    }

    getNextQuestion() {
        const questions = this.state.getCompiledQuestions();
        const currentIndex = this.getCurrentIndex();

        if (currentIndex === -1 || currentIndex === questions.length - 1) {
            return null;
        }

        return questions[currentIndex + 1];
    }

    getPreviousQuestion() {
        const questions = this.state.getCompiledQuestions();
        const currentIndex = this.getCurrentIndex();

        if (currentIndex <= 0) {
            return null;
        }

        return questions[currentIndex - 1];
    }

    navigateNext() {
        const nextQuestion = this.getNextQuestion();

        if (!nextQuestion) {
            return false;
        }

        // Increment questions completed when user moves forward
        const currentCompleted = this.state.getQuestionsCompleted();
        this.state.setQuestionsCompleted(currentCompleted + 1);

        this.state.setCurrentQuestion(nextQuestion.id);
        return true;
    }

    navigatePrevious() {
        const prevQuestion = this.getPreviousQuestion();

        if (!prevQuestion) {
            return false;
        }

        this.state.setCurrentQuestion(prevQuestion.id);
        return true;
    }

    navigateToFirst() {
        const questions = this.state.getCompiledQuestions();

        if (questions.length === 0) {
            return false;
        }

        this.state.setCurrentQuestion(questions[0].id);
        return true;
    }

    getProgress() {
        const questions = this.state.getCompiledQuestions();
        const questionsCompleted = this.state.getQuestionsCompleted();
        const highestProgressShown = this.state.getHighestProgressShown();

        if (questions.length === 0) {
            return 0;
        }

        // Calculate current progress based on questions completed
        const currentProgress = (questionsCompleted / questions.length) * 100;

        // Ensure progress never goes backwards - use the maximum of current and highest shown
        const progress = Math.max(currentProgress, highestProgressShown);

        // Update highest progress shown if current progress is higher
        if (currentProgress > highestProgressShown) {
            this.state.setHighestProgressShown(currentProgress);
        }

        return progress;
    }

    isFirstQuestion() {
        return this.getCurrentIndex() === 0;
    }

    isLastQuestion() {
        const questions = this.state.getCompiledQuestions();
        const currentIndex = this.getCurrentIndex();
        return currentIndex === questions.length - 1;
    }

    findAnswerById(answerId) {
        const questions = this.state.getCompiledQuestions();

        for (const question of questions) {
            if (!question.answers) {
                continue;
            }

            const answer = question.answers.find(a => a.id === answerId);
            if (answer) {
                return { answer, question };
            }
        }

        return null;
    }

    hasSubscription(answerId) {
        const result = this.findAnswerById(answerId);
        const { answer } = result || {};
        return answer && answer.quizData?.subscription === true;
    }

    extractUserSegmentFromAnswer(answerId) {
        const result = this.findAnswerById(answerId);
        const { answer } = result || {};
        return answer && answer.quizData?.userSegment ? answer.quizData.userSegment : null;
    }

    extractSkuFromAnswer(answerId) {
        const result = this.findAnswerById(answerId);
        const { answer } = result || {};
        const sku = answer?.quizData?.sku;
        if (!sku) return null;

        if (QUIZ_SKU_REVISIONS.removals.includes(sku)) return null;

        const replacement = QUIZ_SKU_REVISIONS.replacements[sku];
        return replacement || sku;
    }

    computeRecommendedSkus() {
        const selectedAnswers = this.state.getSelectedAnswers();
        const skuSet = new Set();

        for (const answerId of selectedAnswers) {
            const sku = this.extractSkuFromAnswer(answerId);
            if (sku) {
                skuSet.add(sku);
            }
        }
        return Array.from(skuSet);
    }

    computeSubscriptionPreference() {
        const selectedAnswers = this.state.getSelectedAnswers();

        return selectedAnswers.some(answerId => {
            return this.hasSubscription(answerId);
        });
    }

    updateDerivedState() {
        // Recompute recommended SKUs from all selected answers
        const recommendedSkus = this.computeRecommendedSkus();
        this.state.setRecommendedSkus(recommendedSkus);

        // Recompute subscription preference from all selected answers
        const subscriptionPreference = this.computeSubscriptionPreference();
        this.state.setSubscriptionPreference(subscriptionPreference);

        // Update userSegment from single-choice answers (only single-choice answers have userSegment)
        const selectedAnswers = this.state.getSelectedAnswers();
        let userSegment = null;

        // Find the most recent userSegment from single-choice answers
        // We iterate in reverse to get the latest one
        for (let i = selectedAnswers.length - 1; i >= 0; i--) {
            const segment = this.extractUserSegmentFromAnswer(selectedAnswers[i]);
            if (segment) {
                userSegment = segment;
                break;
            }
        }

        // Only update if we found a segment (don't overwrite with null if it was previously set)
        if (userSegment !== null) {
            this.state.setUserSegment(userSegment);
        }
    }

    // Get selected free gift
    getSelectedGift() {
        const gifts = this.getFreeGifts();

        const selectedAnswers = this.state.getSelectedAnswers();

        for (const answerId of selectedAnswers) {
            const gift = gifts.find(g => g.id === answerId);
            if (gift) {
                return gift;
            }
        }
        // Fallback to first gift
        return gifts[0];
    }
}

/**
 * QuizUI - All rendering and DOM manipulation
 */

class QuizUI {
    constructor(config, state, flowController) {
        this.config = config;
        this.state = state;
        this.flowController = flowController;

        // Cache for DOM elements to avoid repeated queries
        this.elements = {
            // Static elements (cached once, never replaced)
            wrapper: null,
            videoContainer: null,
            staticHeader: null,
            dynamicContainer: null,
            timerElement: null,
            timerImage: null,
            progressBar: null,
            closeIcon: null,

            // Dynamic elements (cached after render, cleared on content change)
            nextButton: null,
            emailInput: null
        };
    }

    // Initialize quiz structure
    renderQuizStructure() {
        const wrapper = document.getElementById('quiz-wrapper');

        if (!wrapper) {
            return;
        }

        wrapper.innerHTML = `
        ${this.renderStaticHeader()}
        <div id="quiz_dynamic"></div>
      `;

        // Cache static elements after initial render
        this.cacheStaticElements();
    }

    // Cache static elements that persist throughout quiz lifecycle
    cacheStaticElements() {
        this.elements.wrapper = document.getElementById('quiz-wrapper');
        this.elements.videoContainer = document.getElementById('quiz-video-container');
        this.elements.staticHeader = document.getElementById('quiz_static');
        this.elements.dynamicContainer = document.getElementById('quiz_dynamic');
        this.elements.timerElement = document.getElementById('timerQuiz');
        this.elements.timerImage = document.getElementById('timer_image');
        this.elements.progressBar = document.getElementById('quiz_progress_active');
        this.elements.closeIcon = document.getElementById('quiz-close-icon');
    }

    // Cache dynamic elements that exist in current question
    cacheDynamicElements() {
        this.elements.nextButton = document.querySelector('[data-quiz-action="next"]');
        this.elements.emailInput = document.getElementById('quiz_email_input');
    }

    // Clear dynamic element cache (called before replacing content)
    clearDynamicCache() {
        this.elements.nextButton = null;
        this.elements.emailInput = null;
    }

    // Safe element accessor - checks cache first, falls back to DOM query
    getElement(cacheKey, id = null, selector = null) {
        // Return cached element if available
        if (this.elements[cacheKey]) {
            return this.elements[cacheKey];
        }

        // Fall back to DOM query if not cached
        let element = null;
        if (id) {
            element = document.getElementById(id);
        } else if (selector) {
            element = document.querySelector(selector);
        }

        // Update cache if element found
        if (element) {
            this.elements[cacheKey] = element;
        }

        return element;
    }

    renderStaticHeader() {
        return `
        <div id="quiz_static" style="position:relative;">
          <div id="quiz_offer_box">
            <div class="timer-count">
              <img id="timer_image" style="background-color:white;" src="${this.state.getTimerGiftImage() || ''}">
              <span id="timerQuiz">${this.state.getTimer()}</span>
            </div>
            <div class="freegift-description">
              <p><span>FREE</span> gift with first order</p>
            </div>
          </div>
          <div id="quiz_progress_container">
            <div id="quiz_progress_active"></div>
          </div>
          ${this.renderLogo()}
          <div class="drawer-close-icon" id="quiz-close-icon" style="display:none;position:absolute;right:10px;bottom:10px;" data-quiz-action="close">
            ${this.getSvgClose()}
          </div>
        </div>
      `;
    }

    // Render logo SVG
    renderLogo() {
        return `
        <svg data-quiz-action="close" id="svg-quizlogo" viewBox="0 0 736.24 213.51">
          <title>carpe logo</title>
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <path d="M456.66,179.77c-.22,17.27-12.29,30.76-29.4,33-2.17.29-4.36.35-6.53.65s-2.75-.59-2.75-2.71q.06-15.54,0-31.07V78.54C418,41.6,442,10.73,478,2.28a77,77,0,0,1,93.2,58.34c9.37,42.4-16.14,82.7-58.45,92.7a80.68,80.68,0,0,1-16.86,1.82c-12,.27-24,.13-36.06.05-2.26,0-3.09.58-3.12,3Zm22.18-63.27c7.7,0,15.44.33,23-.65,20.71-2.68,35.49-23.43,32.06-44.09a38.83,38.83,0,0,0-39.49-32.64c-17.91.36-36.66,14.37-37.62,37.93-.49,12.24,0,24.52-.13,36.79,0,2.22.78,2.73,2.84,2.69,6.42-.11,18.3,0,19.32,0"></path>
              <path d="M235,155.18c-12.51,0-25,.17-37.53,0-34.07-.55-65.53-26.63-72.41-60-5.84-28.39,1.39-53.1,22-73.47C159,9.85,173.71,3.05,190.44.9,231.33-4.34,269,22.63,276.69,62.83a84.48,84.48,0,0,1,1.5,15.47c.15,24.69,0,49.38.12,74.07,0,2.24-.6,2.92-2.85,2.9-13.48-.09-27-.05-40.45-.05Zm-17.8-38.69c6.42,0,12.83-.1,19.25.06,2.36,0,3.06-.7,3-3-.1-11.12,0-22.25-.08-33.38a59.21,59.21,0,0,0-.86-9.67c-3.48-19.66-23-33.86-42.7-31.2A39,39,0,0,0,162.2,83c2.67,18.89,18.92,33.5,38,33.54,5.69,0,11.37,0,17.06,0"></path>
              <path d="M97.29,155.21c-7.07,0-14.14.07-21.2,0C53.82,154.93,35.42,146,20.31,130,9.85,118.86,3.08,105.79,1,90.65c-3.79-27,3.66-50.37,23.74-69.31A77.68,77.68,0,0,1,63.2,1.22,62.68,62.68,0,0,1,75.05.1c16-.12,32,0,48-.1,2.13,0,2.83.55,2.72,2.74-.72,14.32-6.09,25.77-19.63,32.23a29.77,29.77,0,0,1-12.72,2.8c-6.25,0-12.5,0-18.74.38-11.74.7-20.64,6.68-27.62,15.77-17.88,23.28-4.31,58.2,24.64,62.91,6.59,1.07,13.42.79,20.15.84,7.9.06,15,2.19,21.22,7.16,7.35,5.87,10.92,13.69,12.17,22.78.21,1.52.27,3.07.49,4.59.34,2.28-.41,3.12-2.86,3.08-8.53-.14-17.06-.06-25.58-.06Z"></path>
              <path d="M298.59,112.69c0-11.85.12-23.71,0-35.57-.5-41.19,33.07-71.23,64.37-75.74A106.45,106.45,0,0,1,376.73.11C391.83,0,406.94.05,422.05,0c1.37,0,2.62-.11,2.48,1.93-.56,7.94-1.79,15.69-6.69,22.27-6.33,8.51-14.72,13.28-25.47,13.52-6.41.14-12.85-.09-19.22.45a39.07,39.07,0,0,0-33.83,28.66,48.06,48.06,0,0,0-1.48,11.27c-.17,14.05,0,28.1-.07,42.16a34.43,34.43,0,0,1-30,34.32c-2.17.29-4.36.33-6.53.59-2,.24-2.92-.49-2.61-2.54a2.09,2.09,0,0,0,0-.25V112.69"></path>
              <path d="M678.78,117.72c-6.49,0-13.08.46-19.46-.48A39,39,0,0,1,629.16,94c13.33,0,31.47,0,36-.08a34,34,0,0,0,7.85-1c12.82-3.38,21-14.78,21.24-29,0-1.83-.45-2.4-2.33-2.38-8.09.1-16.19,0-24.29,0H629.09A40.44,40.44,0,0,1,632.84,55c6.88-9.75,16-16.11,28.25-16.84,6.48-.39,13,0,19.46-.52a36,36,0,0,0,12-2.78c13.58-6.26,19.13-17.69,19.67-32.12C712.25.5,711.51,0,709.41,0c-16,.08-32,0-48,.1a64.39,64.39,0,0,0-12.08,1.17A77.17,77.17,0,0,0,611.38,21c-20.46,19.1-28.06,42.7-24,70.13,2.13,14.51,8.56,27.13,18.47,37.94,15.08,16.46,33.56,25.73,56.11,26.12,7.23.12,14.46,0,21.69,0v0h26.08c1.23,0,2.49.19,2.45-1.75-.19-9.81-2.63-18.8-9.73-26a32,32,0,0,0-23.62-9.78"></path>
              <path d="M729.71,0a6.46,6.46,0,0,0-6.58,6.38,6.56,6.56,0,0,0,13.11,0A6.39,6.39,0,0,0,729.71,0m0,11.47a4.94,4.94,0,0,1-5-5.09,4.92,4.92,0,1,1,9.84,0,4.88,4.88,0,0,1-4.86,5.05"></path>
              <path d="M731.19,6.57V6.5A1.65,1.65,0,0,0,732.51,5a1.77,1.77,0,0,0-.62-1.4,4,4,0,0,0-2.22-.47,12.54,12.54,0,0,0-2.45.2V9.72h1.48V7.16h.7c.81,0,1.2.31,1.32,1a5.4,5.4,0,0,0,.5,1.55h1.6a4.82,4.82,0,0,1-.47-1.59,1.88,1.88,0,0,0-1.16-1.56m-1.75-.46h-.7V4.28a3.33,3.33,0,0,1,.81-.08c.94,0,1.36.39,1.36,1s-.66.94-1.47.94"></path>
            </g>
          </g>
        </svg>
      `;
    }

    getSvgClose() {
        return `
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      `;
    }

    showCurrentQuestion() {
        const question = this.flowController.getCurrentQuestion();

        if (!question) {
            console.error(`[site-quiz] showCurrentQuestion: No question found, returning early`);
            return;
        }

        // Use cached container or get it fresh
        const container = this.elements.dynamicContainer || this.getElement('dynamicContainer', 'quiz_dynamic');

        if (!container) {
            console.error(`[site-quiz] showCurrentQuestion: Container not found, returning early`);
            return;
        }

        // Clear dynamic cache before replacing content
        this.clearDynamicCache();

        container.innerHTML = this.renderQuestion(question);

        // Cache dynamic elements after render
        this.cacheDynamicElements();

        this.updateProgressBar();
        this.updateCloseButtonVisibility();

        window.scrollTo(0, 0);
        container.scrollTop = 0;

    }

    // Render question based on type
    renderQuestion(question) {
        const renderers = {
            freegift: () => this.renderFreeGiftQuestion(question),
            single: () => this.renderSingleChoiceQuestion(question),
            multiple: () => this.renderMultipleChoiceQuestion(question),
            email: () => this.renderEmailQuestion(question)
        };

        const renderer = renderers[question.type];
        return renderer ? renderer() : '';
    }

    // Render free gift question
    renderFreeGiftQuestion(question) {
        const gifts = this.flowController.getFreeGifts();
        if (gifts.length === 0) {
            console.error('[site-quiz] renderFreeGiftQuestion: No gifts found, returning early');
            return;
        }
        const giftHtml = gifts.map(gift => `
        <div class="gift_block ${this.state.hasAnswer(gift.id) ? 'answer_selected' : ''}"
             id="${gift.id}"
             data-answer-id="${gift.id}"
             data-variant-id="${gift.variantId}"
             data-gift-image="${gift.timerImage}"
             data-quiz-action="select-gift">
          <img class="gift_image lazyload" data-src="${gift.image}">
          <div class="gift_title">
            <p>${gift.subtitle}</p>
            <h3>${gift.title}</h3>
          </div>
          <div class="gift_action">
            <p class="gift_price">${gift.details}</p>
            <button class="gift_ATC">
              <svg class="svg-plusbutton" viewBox="0 0 40 40">
                <title>plus icon</title>
                <polygon class="st0" points="27.75,18.77 21.23,18.77 21.23,12.25 18.77,12.25 18.77,18.77 12.25,18.77 12.25,21.23 18.77,21.23 18.77,27.75 21.23,27.75 21.23,21.23 27.75,21.23 "/>
              </svg>
              <svg class="svg-checkmark" viewBox="0 0 40 40">
                <title>checkmark icon</title>
                <polygon class="st0" points="28.27,13.65 19.05,22.87 14.43,18.26 12.7,20 17.31,24.61 19.05,26.35 20.78,24.61 30,15.39   "/>
              </svg>
            </button>
          </div>
        </div>
      `).join('');

        return `
        <div class="quiz_slide" id="${question.id}" data-question-id="${question.id}">
          <div class="question free_gift">
            <h2>${question.title}</h2>
            <p>${question.subtitle}</p>
          </div>
          <div class="freegift_answers">
            ${giftHtml}
          </div>
          <div class="next_button_background">
            <button class="next_button" data-quiz-action="next">
              ${question.ctaText}
            </button>
          </div>
        </div>
      `;
    }

    // Render single choice question
    renderSingleChoiceQuestion(question) {
        const answersHtml = question.answers.map(answer => `
        <button class="${this.state.hasAnswer(answer.id) ? 'answer_selected' : ''}"
                id="${answer.id}"
                data-answer-id="${answer.id}"
                data-quiz-action="select-answer">
          ${answer.text}
        </button>
      `).join('');

        const hasSelection = question.answers.some(a => this.state.hasAnswer(a.id));

        return `
        <div class="quiz_slide one_answer" id="${question.id}" data-question-id="${question.id}">
          <div class="question">
            <h2>${question.title}</h2>
            ${question.subtitle ? `<p>${question.subtitle}</p>` : ''}
          </div>
          <div class="answers">
            ${answersHtml}
          </div>
          <div class="next_button_background">
            <button class="next_button"
                    data-quiz-action="next"
                    ${hasSelection ? '' : 'disabled'}>
              NEXT
            </button>
          </div>
        </div>
      `;
    }

    // Render multiple choice question
    renderMultipleChoiceQuestion(question) {
        const answersHtml = question.answers.map(answer => `
        <button class="${this.state.hasAnswer(answer.id) ? 'answer_selected' : ''}"
                id="${answer.id}"
                data-answer-id="${answer.id}"
                data-quiz-action="select-answer">
          ${answer.text}
        </button>
      `).join('');

        const hasSelection = question.answers.some(a => this.state.hasAnswer(a.id));

        return `
        <div class="quiz_slide" id="${question.id}" data-question-id="${question.id}">
          <div class="question">
            <h2>${question.title}</h2>
            ${question.subtitle ? `<p>${question.subtitle}</p>` : ''}
          </div>
          <div class="answers">
            ${answersHtml}
          </div>
          <div class="next_button_background">
            <button class="next_button"
                    data-quiz-action="next"
                    ${hasSelection ? '' : 'disabled'}>
              NEXT
            </button>
          </div>
        </div>
      `;
    }

    renderEmailQuestion(question) {
        return `
        <div class="quiz_slide" id="${question.id}" data-question-id="${question.id}">
          <div class="question">
            <p>${question.subtitle}</p>
            <h2>${question.title}</h2>
          </div>
          <label for="quiz_email_input">Email</label>
          <input type="text"
                 id="quiz_email_input"
                 autocomplete="on"
                 name="email">
          <div class="next_button_background" style="text-align:center;">
            <button type="submit"
                    class="next_button"
                    data-quiz-action="submit-email"
                    style="margin-bottom: 10px;">
              ${question.ctaText}
            </button>
            <a class="skip_button" data-quiz-action="submit">
              ${question.skipText}
            </a>
          </div>
        </div>
      `;
    }

    updateProgressBar() {
        const progressBar = this.elements.progressBar || this.getElement('progressBar', 'quiz_progress_active');

        if (!progressBar) {
            return;
        }

        const progress = this.flowController.getProgress();
        progressBar.style.width = `${progress}%`;
    }

    updateCloseButtonVisibility() {
        const closeIcon = this.elements.closeIcon || this.getElement('closeIcon', 'quiz-close-icon');

        if (!closeIcon) {
            return;
        }

        const isFirstOrLast = this.flowController.isFirstQuestion() || this.flowController.isLastQuestion();
        closeIcon.style.opacity = isFirstOrLast ? '1' : '0';
    }

    updateTimerGiftImage(imageUrl) {
        const timerImage = this.elements.timerImage || this.getElement('timerImage', 'timer_image');

        if (!timerImage) {
            return;
        }

        this.state.setTimerGiftImage(imageUrl || '');
        timerImage.src = this.state.getTimerGiftImage();
    }

    // Update timer display
    updateTimerDisplay() {
        const timerElement = this.elements.timerElement || this.getElement('timerElement', 'timerQuiz');
        if (!timerElement) {
            return;
        }
        timerElement.textContent = this.state.getTimer();
    }

    updateNextButton() {
        const nextButton = this.elements.nextButton || this.getElement('nextButton', null, '[data-quiz-action="next"]');

        if (!nextButton) {
            return;
        }

        const currentQuestion = this.flowController.getCurrentQuestion();

        if (!currentQuestion || !currentQuestion.answers) {
            return;
        }

        const hasSelection = currentQuestion.answers.some(a => this.state.hasAnswer(a.id));
        nextButton.disabled = !hasSelection;
    }

    showCompletionVideo() {
        const videoContainer = this.elements.videoContainer;

        if (!videoContainer) {
            console.warn('video container not found');
            return;
        }

        videoContainer.classList.remove('hidden');
        const video = videoContainer.querySelector('video');
        if (!video) {
            return;
        }
        video.play();

        // Clear cache since we've replaced all content
        this.clearCache();
    }
    clearCache() {
        this.elements = {
            wrapper: null,
            staticHeader: null,
            dynamicContainer: null,
            timerElement: null,
            timerImage: null,
            progressBar: null,
            closeIcon: null,
            nextButton: null,
            emailInput: null
        };
    }
}

/**
 * QuizEventHandler - Event delegation and handling
 */

class QuizEventHandler {
    _isSubmitting = false;
    constructor(config, state, flowController, ui, integrations) {
        this.config = config;
        this.state = state;
        this.flowController = flowController;
        this.ui = ui;
        this.integrations = integrations;
    }

    attachEventListeners() {
        // Main click handler with event delegation
        document.addEventListener('click', (e) => this.handleClick(e));

        // Browser back button
        window.addEventListener('popstate', (e) => this.handleBrowserBack(e));

        // Hash change fallback (for direct hash navigation)
        window.addEventListener('hashchange', () => this.handleBrowserBack({ state: null }));
    }

    handleClick(e) {
        const action = e.target.closest('[data-quiz-action]')?.dataset.quizAction;

        if (!action) {
            return;
        }

        const handlers = {
            'select-answer': () => this.handleSelectAnswer(e),
            'select-gift': () => this.handleSelectGift(e),
            'next': () => this.handleNext(e),
            'submit-email': () => this.handleSubmitEmail(e),
            'submit': () => this.handleSubmit(e),
            'close': () => this.handleClose(e)
        };

        const handler = handlers[action];

        if (handler) {
            handler();
        }
    }

    handleSubmitEmail(e) {
        e.preventDefault();

        const emailContainer = e.target.closest('.quiz_slide'); // the nearest slide wrapper
        const email = emailContainer.querySelector('input[name="email"]').value;
        this.state.setEmail(email);
        this.submitQuiz();
    }

    handleSelectAnswer(e) {
        const button = e.target.closest('[data-answer-id]');

        if (!button) {
            return;
        }

        const answerId = button.dataset.answerId;
        const currentQuestion = this.flowController.getCurrentQuestion();

        if (!currentQuestion) {
            return;
        }

        if (currentQuestion.type === 'single') {
            this.handleSelectSingleChoiceAnswer(answerId, currentQuestion, button);
        } else {
            this.handleSelectMultipleChoiceAnswer(answerId, button);
        }

        this.flowController.addConditionalFlows(answerId);
        this.ui.updateNextButton();

    }

    handleSelectSingleChoiceAnswer(answerId, currentQuestion, button) {
        this.state.clearAnswersForQuestion(currentQuestion.answers);
        this.state.addAnswer(answerId);

        // Update derived state (recommendedSkus, subscriptionPreference, userSegment)
        this.flowController.updateDerivedState();

        const questionContainer = document.getElementById(currentQuestion.id);
        if (questionContainer) {
            questionContainer.querySelectorAll('.answer_selected').forEach(b => {
                if (b !== button) {
                    b.classList.remove('answer_selected');
                }
            });
        }
        button.classList.add('answer_selected');

        setTimeout(() => this.navigateNext(), 100);
    }

    handleSelectMultipleChoiceAnswer(answerId, button) {
        if (this.state.hasAnswer(answerId)) {
            this.state.removeAnswer(answerId);
            button.classList.remove('answer_selected');
        } else {
            this.state.addAnswer(answerId);
            button.classList.add('answer_selected');
        }

        // Update derived state (recommendedSkus, subscriptionPreference, userSegment)
        this.flowController.updateDerivedState();
    }

    handleSelectGift(e) {
        const giftBlock = e.target.closest('[data-answer-id]');

        if (!giftBlock) {
            return;
        }

        const giftId = giftBlock.dataset.answerId;
        const giftImage = giftBlock.dataset.giftImage;

        // If this gift is already selected, do nothing (don't allow deselection)
        if (giftBlock.classList.contains('answer_selected')) {
            return;
        }

        const gifts = this.flowController.getFreeGifts();
        // Remove all gift answers from state
        gifts.forEach(gift => {
            this.state.removeAnswer(gift.id);
        });

        // Add the selected gift
        this.state.addAnswer(giftId);

        // Update UI - remove selection from other gifts
        document.querySelectorAll('.gift_block').forEach(block => {
            block.classList.remove('answer_selected');
        });
        giftBlock.classList.add('answer_selected');

        this.ui.updateTimerGiftImage(giftImage);

        // Update derived state (recommendedSkus, subscriptionPreference, userSegment)
        this.flowController.updateDerivedState();
    }

    handleNext(e) {
        e.preventDefault();
        this.navigateNext();
    }

    navigateNext() {
        const nextQuestion = this.flowController.getNextQuestion();

        if (!nextQuestion) {
            return;
        }

        setTimeout(() => {
            this.flowController.navigateNext();
            this.ui.showCurrentQuestion();
            this.updateUrl();
        }, 500);
    }

    navigatePrevious() {
        const prevQuestion = this.flowController.getPreviousQuestion();

        if (!prevQuestion) {
            return;
        }

        setTimeout(() => {
            this.flowController.navigatePrevious();
            this.ui.showCurrentQuestion();
            this.updateUrl();
        }, 500);
    }


    handleSubmit(e) {
        e.preventDefault();

        this.submitQuiz();
    }



    async submitQuiz() {
        // Prevent multiple submissions
        if (this._isSubmitting) {
            return;
        }
        this._isSubmitting = true;

        this.ui.showCompletionVideo();

        // change cart page title if quiz is completed 
        sessionStorage.setItem('carpe_quiz_completed', 'true');

        // Fire completion event with recommended products
        const recommendedSkus = this.state.getRecommendedSkus();
        this.integrations.trackEvent(QuizIntegrations.EVENTS.FINISH_QUIZ, { recs: recommendedSkus });

        // Fire Convert conversions based on submit state
        const useSubscription = !!this.state.getSubscriptionPreference();
        const email = this.state.getEmail();
        if (useSubscription) {
            this.integrations.triggerConvertEventSubmitQuizWithSubPreference();
        } else {
            this.integrations.triggerConvertEventSubmitQuizWithoutSubPreference();
        }
        if (email) {
            this.integrations.triggerConvertEventSubmitQuizWithEmail();
        }

        // Start both async operations in parallel
        const operations = [];
        const startTime = Date.now();

        // recommended products first, then free gift so gift appears first on cart page
        operations.push(
            (async () => {
                await this.addRecommendedProductsToCart();
                await this.addFreeGiftToCart();
            })()
        );

        operations.push(this.integrations.submitKlaviyoData());

        // Wait for both operations to complete
        try {
            await Promise.all(operations);
        } catch (error) {
            console.error('Error in submitQuiz operations:', error);
            // Don't redirect if cart add failed
            if (error.message && error.message.includes('cart')) {
                console.error('There was an error adding items to your cart. Please try again.');
                this._isSubmitting = false; // Reset on error
                return;
            }
            // For other errors (like email), continue
        }

        // Ensure at least 3300ms has elapsed
        const elapsed = Date.now() - startTime;
        if (elapsed < 3300) {
            await new Promise(resolve => setTimeout(resolve, 3300 - elapsed));
        }

        window.location.href = '/cart';
    }


    getFreeGiftPayload() {
        const items = [];
        const selectedGift = this.flowController.getSelectedGift();
        if (selectedGift && selectedGift.variantId) {
            items.push({
                id: selectedGift.variantId,
                quantity: 1
            });
        }
        return items;
    }


    getItemTotal(sku) {
        const itemTotalCounts = {
            'CP-CU': 4,
            'CP-22': 2,
            'CP-SR-KIT': 2,
            'CP-ADM': 4,
        }

        for (const [prefix, count] of Object.entries(itemTotalCounts)) {
            if (sku.includes(prefix)) {
                return count;
            }
        }

        return 1;
    }

    getRecommendedProductsPayload() {
        const items = [];
        const useSubscription = this.state.getSubscriptionPreference();
        const recommendedSkus = this.state.getRecommendedSkus();

        const variants = window.carpe_variants;
        if (!variants) {
            console.error('window.carpe_variants not found');
            return [];
        }
        recommendedSkus.forEach((sku) => {
            const variant = variants[sku];
            console.log('Recommended SKU:', sku);
            if (variant) {
                const item = {
                    id: String(variant.id),
                    quantity: 1,
                    item_total: this.getItemTotal(sku)
                }
                if (useSubscription && variant.selling_plan_allocations?.length > 0) {
                    const sellingPlanId = variant.selling_plan_allocations?.[0]?.selling_plan_id;
                    item.selling_plan = sellingPlanId;
                }

                items.push(item)
            }
            else {
                console.error('Variant not found for SKU:', sku);
            }
        });
        return items;
    }

    async addFreeGiftToCart() {
        const items = this.getFreeGiftPayload();
        if (items.length === 0) {
            return;
        }
        return await this.addItemsToCart(items);
    }

    async addRecommendedProductsToCart() {
        const items = this.getRecommendedProductsPayload();

        if (items.length === 0) {
            return;
        }
        return await this.addItemsToCart(items);
    }

    async addItemsToCart(items) {
        // Validate items array
        if (!items || items.length === 0) {
            console.error('Cannot add items to cart: items array is empty');
            throw new Error('No items to add to cart');
        }

        // Validate each item has required fields
        for (const item of items) {
            if (!item.id || !item.quantity) {
                console.error('Invalid item:', item);
                throw new Error(`Invalid item structure: ${JSON.stringify(item)}`);
            }
        }

        const payload = { items };

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                // Get the error response body for better debugging
                let errorMessage = 'Failed to add items to cart';
                let errorDetails = null;

                try {
                    const errorText = await response.text();
                    console.error('Cart API error response:', errorText);

                    try {
                        errorDetails = JSON.parse(errorText);
                        errorMessage = errorDetails.description || errorDetails.message || errorMessage;
                    } catch (e) {
                        errorMessage = errorText || errorMessage;
                    }
                } catch (e) {
                    console.error('Could not read error response:', e);
                }

                console.error('Cart API error details:', {
                    status: response.status,
                    statusText: response.statusText,
                    errorMessage: errorMessage,
                    errorDetails: errorDetails,
                    payload: payload
                });

                throw new Error(`Failed to add items to cart (${response.status}): ${errorMessage}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Error adding items to cart:', error);
            throw error; // Re-throw to allow caller to handle
        }
    }
    handleClose(e) {
        e.preventDefault();

        // Get referrer URL from state
        const referrerUrl = this.state.getReferrerUrl();

        // Navigate to referrer if valid, otherwise go to home page
        if (referrerUrl) {
            window.location.href = referrerUrl;
        } else {
            window.location.href = '/';
        }
    }

    // Handle browser back button
    handleBrowserBack(event) {

        // Extract state from event or fallback to hash
        const hash = location.hash;
        const state = event?.state || (hash ? { questionId: hash.substring(1) } : null);

        if (!state || !state.questionId) {
            // No question ID, close the quiz
            this.handleClose({ preventDefault: () => { } });
            return;
        }

        const questionId = state.questionId;

        // Restore activeFlows if they differ from current state
        if (state.activeFlows && Array.isArray(state.activeFlows)) {
            const currentFlows = this.state.getActiveFlows();
            const flowsMatch = currentFlows.length === state.activeFlows.length &&
                currentFlows.every((flow, index) => flow === state.activeFlows[index]);

            if (!flowsMatch) {
                this.state.setActiveFlows(state.activeFlows);
                this.flowController.compileQuestions();
            }
        }

        // Validate the question exists in compiled questions (after potential recompilation)
        const question = this.flowController.getQuestionById(questionId);


        if (!question) {
            // Invalid question ID, close the quiz
            console.warn(`[site-quiz] handleBrowserBack: Question not found in compiled questions, closing quiz`);
            this.handleClose({ preventDefault: () => { } });
            return;
        }

        // Update state to match the URL
        this.state.setCurrentQuestion(questionId);

        // Always show the question if it exists (even if it's the first question)
        // The quiz should only close when there's no question ID (handled above)
        this.ui.showCurrentQuestion();
    }

    // Update URL with question hash
    updateUrl() {
        const currentId = this.state.getCurrentQuestionId();

        if (currentId) {
            const state = {
                questionId: currentId,
                activeFlows: [...this.state.getActiveFlows()]
            };
            history.pushState(state, document.title, `${location.pathname}#${currentId}`);
        }
    }
}

/**
 * QuizIntegrations - External integrations (Klaviyo, analytics, cart)
 */

class QuizIntegrations {
    // Google Analytics event names
    static EVENTS = {
        START_QUIZ: 'start_quiz',
        FINISH_QUIZ: 'finish_quiz',
    }

    // Convert conversion IDs (quiz submit variants)
    static CONVERT = {
        SUBMIT_QUIZ_WITH_SUB_PREFERENCE: '100333600',
        SUBMIT_QUIZ_WITHOUT_SUB_PREFERENCE: '100333601',
        SUBMIT_QUIZ_WITH_EMAIL: '100333602',
    }

    constructor(config, state, flowController) {
        this.config = config;
        this.state = state;
        this.flowController = flowController;
    }

    safeTrack(checkFn, executeFn, apiName, retries = 50) {
        const api = checkFn();

        if (typeof api === 'function') {
            executeFn(api);
        } else if (retries > 0) {
            setTimeout(() => {
                this.safeTrack(checkFn, executeFn, apiName, retries - 1);
            }, 100);
        } else {
            console.warn(`[Quiz] ${apiName} not available after timeout`);
        }
    }

    trackEvent(eventName, params = {}) {
        this.safeTrack(
            () => window.gtag,
            (gtag) => {
                gtag('event', eventName, params);
            },
            'gtag'
        );
    }

    triggerConvertConversion(conversionId) {
        if (!conversionId) return;

        window._conv_q = window._conv_q || [];
        window._conv_q.push(["triggerConversion", String(conversionId)]);
    }

    // Quiz - Submit Quiz w/ Sub Preference 100333600
    triggerConvertEventSubmitQuizWithSubPreference() {
        this.triggerConvertConversion(QuizIntegrations.CONVERT.SUBMIT_QUIZ_WITH_SUB_PREFERENCE);
    }

    // Quiz - Submit Quiz w/o Sub Preference 100333601
    triggerConvertEventSubmitQuizWithoutSubPreference() {
        this.triggerConvertConversion(QuizIntegrations.CONVERT.SUBMIT_QUIZ_WITHOUT_SUB_PREFERENCE);
    }

    // Quiz - Submit Quiz w/ Email 100333602
    triggerConvertEventSubmitQuizWithEmail() {
        this.triggerConvertConversion(QuizIntegrations.CONVERT.SUBMIT_QUIZ_WITH_EMAIL);
    }

    async submitKlaviyoData() {
        const email = this.state.getEmail();
        if (!email) {
            console.warn('No email found, skipping Klaviyo request');
            return;
        }

        // loosely check for valid email format, avoid sending invalid emails to Klaviyo
        function isValidEmailLoose(email) {
            return typeof email === 'string'
                && email.length <= 254
                && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        }

        if (!isValidEmailLoose(email)) {
            console.error('Invalid email, skipping Klaviyo request for: ', email);
            return;
        }

        const companyId = 'Xr5YRc';
        const listId = 'VKVe9c';

        const recommendedSkus = this.state.getRecommendedSkus();
        const userSegment = this.state.getUserSegment();
        const subscriptionPreference = this.state.getSubscriptionPreference();
        const selectedAnswers = this.state.getSelectedAnswers();

        const klaviyoPayload = {
            data: {
                type: 'subscription',
                attributes: {
                    profile: {
                        data: {
                            type: 'profile',
                            attributes: {
                                email: email,
                                subscriptions: {
                                    email: {
                                        marketing: {
                                            consent: 'SUBSCRIBED'
                                        }
                                    }
                                },
                                properties: {
                                    quiz_type: this.flowController.quizType,
                                    quiz_recommendedSkus: recommendedSkus.length > 0 ? recommendedSkus.join(',') : null,
                                    quiz_userSegment: userSegment || null,
                                    quiz_subscriptionPreference: subscriptionPreference || false,
                                    quiz_selectedAnswers: selectedAnswers.length > 0 ? selectedAnswers.join(',') : null
                                }
                            }
                        }
                    }
                },
                relationships: {
                    list: {
                        data: {
                            type: 'list',
                            id: listId
                        }
                    }
                }
            }
        };

        const url = `https://a.klaviyo.com/client/subscriptions?company_id=${companyId}`;
        const headers = {
            'accept': 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            'revision': '2025-10-15'
        };

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers,
                body: JSON.stringify(klaviyoPayload)
            });

            // Get response headers
            const responseHeaders = {};
            response.headers.forEach((value, key) => {
                responseHeaders[key] = value;
            });

            const status = response.status;
            const statusText = response.statusText;
            const contentType = response.headers.get('content-type');
            const contentLength = response.headers.get('content-length');

            // Always read the response body as text first
            const responseText = await response.text();

            // Check response status first
            if (!response.ok) {
                // Try to parse error response if it has content
                if (contentType && contentType.includes('application/json') && responseText) {
                    try {
                        const errorData = JSON.parse(responseText);
                        console.error('[Klaviyo] Subscription error (JSON):', errorData);
                    } catch (e) {
                        console.error('[Klaviyo] Subscription error (non-JSON body):', {
                            status,
                            statusText,
                            body: responseText,
                            parseError: e.message
                        });
                    }
                } else {
                    console.error('[Klaviyo] Subscription error (no JSON body):', {
                        status,
                        statusText,
                        body: responseText || '(empty)'
                    });
                }
                return Promise.resolve();
            }

            // For successful responses (including 202), log the body if present
            if (responseText && responseText.trim().length > 0) {
                if (contentType && contentType.includes('application/json')) {
                    try {
                        const responseData = JSON.parse(responseText);
                        return responseData;
                    } catch (e) {
                        console.warn('[Klaviyo] Response body is not valid JSON:', {
                            body: responseText,
                            parseError: e.message
                        });
                        return Promise.resolve();
                    }
                } else {
                    console.log('[Klaviyo] Subscription response body (non-JSON):', responseText);
                    return Promise.resolve();
                }
            } else {
                return Promise.resolve();
            }
        } catch (err) {
            console.error('[Klaviyo] Subscription request error:', {
                error: err,
                message: err.message,
                stack: err.stack,
                email,
                listId,
                companyId
            });
            return Promise.resolve();
        }
    }

}

/**
 * QuizTimer - Timer management
 */

class QuizTimer {
    constructor(config, state, ui) {
        this.config = config;
        this.state = state;
        this.ui = ui;
        this.interval = null;
        this.isRunning = false;
    }

    start() {
        if (this.isRunning) {
            return;
        }

        this.isRunning = true;
        const interval = 1000
        this.interval = setInterval(() => {
            this.tick();
        }, interval);
    }

    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
        this.isRunning = false;
    }

    tick() {

        const currentValue = this.state.getTimer();
        const [minutes, seconds] = currentValue.split(':').map(Number);

        let newMinutes = minutes;
        let newSeconds = seconds - 1;

        if (newSeconds < 0) {
            newSeconds = 59;
            newMinutes -= 1;
        }

        if (newMinutes < 0) {
            this.stop();
            this.state.setTimer('0:00');
            this.ui.updateTimerDisplay();
            return;
        }

        const formattedSeconds = newSeconds < 10 ? `0${newSeconds}` : newSeconds;
        const newValue = `${newMinutes}:${formattedSeconds}`;

        this.state.setTimer(newValue);
        this.ui.updateTimerDisplay();
    }

    reset() {
        this.stop();
        this.state.setTimer('10:00');
        this.ui.updateTimerDisplay();
    }
}

/**
 * QuizApp - Main orchestrator
 * Thin class that coordinates all subsystems
 */

class QuizApp {
    constructor(config) {
        this.config = config;

        // Resolve quiz type
        const quizType = this.getQuizType();

        // Initialize subsystems
        this.state = new QuizState(quizType);
        this.flowController = new QuizFlowController(config, this.state, quizType);
        this.ui = new QuizUI(config, this.state, this.flowController);
        this.integrations = new QuizIntegrations(config, this.state, this.flowController);
        this.eventHandler = new QuizEventHandler(
            config,
            this.state,
            this.flowController,
            this.ui,
            this.integrations
        );
        this.timer = new QuizTimer(config, this.state, this.ui);
    }

    getQuizType() {
        const quizType = window.quiz_2026_type;
        return quizType || 'primary';
    }

    init() {
        if (!window.carpe_variants) {
            console.error('window.carpe_variants not found. Quiz will fail to add recommended products to cart.');
        }

        this.flowController.initializeFlows();
        this.ui.renderQuizStructure();
        this.eventHandler.attachEventListeners();
        this.showFirstQuestion();
        this.integrations.trackEvent(QuizIntegrations.EVENTS.START_QUIZ);
        this.startTimer();

    }

    showFirstQuestion() {
        const currentId = this.state.getCurrentQuestionId();

        if (currentId) {
            const question = this.flowController.getQuestionById(currentId);

            if (question) {
                this.ui.showCurrentQuestion();
                this.eventHandler.updateUrl();
                return;
            }
        }

        this.flowController.navigateToFirst();
        this.ui.showCurrentQuestion();
        this.eventHandler.updateUrl();
    }

    startTimer() {
        this.timer.start();
    }

    stopTimer() {
        this.timer.stop();
    }

    getState() {
        return this.state.data;
    }

    getQuestions() {
        return this.state.getCompiledQuestions();
    }

    reset() {
        this.timer.stop();
        this.state.reset();
        this.flowController.initializeFlows();
        this.timer.reset();
        this.showFirstQuestion();
    }
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        const app = new QuizApp(QuizConfig);
        app.init();
        window.quizAppInstance = app;
    });
} else {
    const app = new QuizApp(QuizConfig);
    app.init();
    window.quizAppInstance = app;
}

